import { faCircleXmark, faFileXmark } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { VaccineRecordErrorVariant } from '@spike/pets-action';
import { FunctionComponent } from 'react';
import styles from './VaccineRecordErrorModalView.module.scss';

interface VariantContent {
    icon: IconProp;
    title: string;
    body: string;
}

const CONTENT_BY_VARIANT: Readonly<Record<VaccineRecordErrorVariant, VariantContent>> = {
    INVALID_FILE: {
        icon: faFileXmark,
        title: 'Invalid File',
        body: "We couldn't verify this file as a vaccine record. Please upload a clear photo or PDF of the vaccination certificate."
    },
    UNABLE_TO_VALIDATE: {
        icon: faCircleXmark,
        title: 'Unable To Validate',
        body: "We couldn't verify this file right now. Please try again or upload a different document."
    }
};

interface Props {
    variant: VaccineRecordErrorVariant;
    onCancel: () => void;
    onUploadAgain: () => void;
}

/**
 * Presentation for the vaccine-record upload error modal. Deliberately holds no
 * redux wiring so every flow that uploads a vaccine record renders the same
 * modal from its own slice.
 */
export const VaccineRecordErrorModalView: FunctionComponent<Props> = props => {
    const content = CONTENT_BY_VARIANT[props.variant];

    return (
        <GenericModal
            className={styles.modal}
            onClose={props.onCancel}
            footer={
                <div className={styles.footer}>
                    <Button
                        className={styles.button}
                        label="Cancel"
                        variant="black"
                        size="large"
                        onClick={props.onCancel}
                    />
                    <Button
                        className={styles.button}
                        label="Upload Again"
                        variant="green"
                        size="large"
                        onClick={props.onUploadAgain}
                    />
                </div>
            }
        >
            <div className={styles.content}>
                <div className={styles.iconCircle}>
                    <FontAwesomeIcon
                        icon={content.icon}
                        className={styles.icon}
                    />
                </div>
                <h3 className={styles.title}>{content.title}</h3>
                <p className={styles.body}>{content.body}</p>
            </div>
        </GenericModal>
    );
};

export default VaccineRecordErrorModalView;
